import { Image, Platform, Text } from 'react-native';
import { Theme, ThemedText, ThemedView } from '../../theme'
import { TRANSACTION_SCREEN } from './Transactions'
import TransactionEmptyState from '../../../assets/Icons/TransactionEmptyState';
import { useTheme } from '@shopify/restyle';

const ZeroState = ({isLMSUser=false}) => {
    const {colors} = useTheme<Theme>();
    return (
        <ThemedView
            mt='5xl'
            justifyContent='center'
            alignItems='center'
            backgroundColor='bg-surface-primary'
            mx='5xl'
            >
            <TransactionEmptyState bgColor={colors['icon-primary-hover']} color1={colors['icon-emphasis-primary']} color2={colors['bg-fill-emphasis-secondary']} size={200}/>
            <ThemedText variant='b2s' color='text-secondary' textAlign='center'>
                {isLMSUser?
                    'No transactions to show':
                    'Your transactions will show up here after you start your credit line'
                }
            </ThemedText>
        </ThemedView>
    )
}

export default ZeroState